export default "__VITE_ASSET__1643bd64__"